import { Injectable } from '@angular/core';

import { ImagesConfig } from '@frontend/sports/common/client-config-data-access';

@Injectable({
    providedIn: 'root',
})
export class ImageQualityService {
    constructor(private imageConfig: ImagesConfig) {}

    setImageQuality(imageSource: string, qualityValue: string): string {
        const allowedExtensions = new RegExp(this.imageConfig.imageQualityParams?.allowedImageTypes, 'i');

        if (imageSource && imageSource.match(allowedExtensions) && !imageSource.includes('q='))
            return (imageSource += imageSource.includes('?') ? '&' + qualityValue : '?' + qualityValue);

        return imageSource;
    }
}
